import $ from 'jquery';
import enumList from 'web/utils/enumList';
import {DataTableComponent} from 'web/components/CommonComponent';
import {useDispatch, useSelector} from 'react-redux';

export const useConditionListModal = (baseComponent) => {
  const dispatch = useDispatch();
  const conditionList = useSelector(
    (state) => state.condition.conditionList?.data,
  );

  const prepareDispatchListTable = () => {
    // 定義資料內容
    const dataSet = conditionList.map((conditionItem) => {
      return [
        conditionItem.conditionCode,
        conditionItem.conditionName,
        conditionItem.description,
        conditionItem.flgStatus,
      ];
    });

    // 定義欄位屬性
    const columnConfig = [
      {title: '指派條件名稱', className: 'dt-center', data: 1},
      {title: '指派條件說明', className: 'dt-center', data: 2},
      {
        orderable: false,
        title: '啟用',
        data: 3,
        className: 'dt-center',
        render: (data, type, row, meta) => {
          const enableId = 'eab-condition-' + meta.row;
          const isChecked = data === enumList.flgStatus.active ? 'checked' : '';
          const enableButton = baseComponent.checkPermission(
            enumList.moduleEnums.position,
            enumList.accessModeEnums.update,
          )
            ? ''
            : 'disabled';
          return `<div class="form-check form-switch">
                                  <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                                  <label class="form-check-label" for="${enableId}"></label>
                              </div>`;
        },
      },
      {
        title: '編輯',
        className: 'dt-center',
        orderable: false,
        render: (data, type, row, meta) => {
          const enableButton = baseComponent.checkPermission(
            enumList.moduleEnums.position,
            enumList.accessModeEnums.update,
          )
            ? ''
            : 'disabled';
          return `<button type="button" 
                     class="btn btn-sm btn-link ${enableButton}"
                     id="edit-condition-${meta.row}">
                    <svg class="btn__icon 
                      btn__icon--sm me-1" aria-hidden="true">
                        <use href="#ico-edit"></use>
                    </svg>
                    修改
                </button>`;
        },
      },
    ];

    // 定義排序設定
    const orderConfig = {
      // idx: 1,
      // dir: 'asc',
    };

    // 定義固定欄位設定
    const fixedColumnsConfig = {
      start: 1,
    };
    // 先清除datatable
    if ($.fn.DataTable.isDataTable('#datatable__dispatchList')) {
      $('#datatable__dispatchList').empty();
      $('#datatable__dispatchList').DataTable().destroy();
    }

    return DataTableComponent(
      '#datatable__dispatchList',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
    );
  };

  return {prepareDispatchListTable};
};
